<template>
  <div id="index">
    <common-header></common-header>
    <div class="block-top">
      <p class="display-3 mincho" style="text-align:center;paddng:10px;">
        <img class="topMessage" src="@/assets/image/topMessage-min.png" alt="平成を語ろう">
      </p>
    </div>
    <div class="block-top block">
      <v-btn color="light-blue" large dark @click="login('twitter')">
        <i class="fab fa-twitter"></i>
        &nbsp;ログイン
      </v-btn>
      <v-btn color="indigo" large dark @click="login('facebook')">
        <i class="fab fa-facebook"></i>
        &nbsp;ログイン
      </v-btn>
      <v-btn color="red" large dark @click="login('google')">
        <i class="fab fa-google"></i>
        &nbsp;ログイン
      </v-btn>
    </div>
    <div class="block">
      <p class="title">ログインして平成年表を投稿しよう。</p>
      <p class="title">名前はログイン後に変更できます。</p>
    </div>
  <common-footer></common-footer>
  </div>
</template>

<script>
import firebase from 'firebase'
import { providerTwitter, providerFacebook, providerGoogle, db } from '../../main'
import CommonHeader from '../common/CommomHeader'
import CommonFooter from '../common/CommomFooter'
export default {
  name: 'Login',
  data () {
    return {
    }
  },
  methods: {
    login (p) {
      let provider = providerTwitter
      if (p === 'twitter') {
        provider = providerTwitter
      } else if (p === 'facebook') {
        provider = providerFacebook
      } else if (p === 'google') {
        provider = providerGoogle
      } else {
        return
      }
      firebase.auth().signInWithPopup(provider).then(function (result) {
        if (result.additionalUserInfo.isNewUser) {
          var userinfo = result.user
          db.collection('user').doc(userinfo.uid).set({
            uid: userinfo.uid,
            displayName: userinfo.displayName,
            photoURL: userinfo.photoURL
          })
        }
        this.$router.push({name: 'Index'})
      }.bind(this)).catch(function (error) {
        console.log(error)
      })
    }
  },
  head: {
    title: function () {
      return {
        inner: 'ログイン',
        separator: '|',
        complement: '平成年表'
      }
    },
    meta: function () {
      return [
        {property: 'og:title', content: 'ログイン｜平成年表'},
        {name: 'description', content: 'ログインしてあなたの想い出を投稿しよう！'},
        {name: 'twitter:image', content: 'https://www.katsulabo.com/heisei/image/heisei-nenpyo.png'},
        {property: 'og:image', content: 'https://www.katsulabo.com/heisei/image/heisei-nenpyo.png'}
      ]
    }
  },
  components: {
    CommonHeader,
    CommonFooter
  }
}
</script>

<style scoped>
@import url("../../assets/css/common.css");
.mainBtn{
  margin: 24px 0px;
  width: 100%;
  text-align:center;
}
.block{
  margin-top: 24px;
  width: 100%;
  text-align:center;
}
.block-top{
  margin-top: 10%;
  margin-bottom: 10%;
  width: 100%;
}
.block-subtitle {
  padding:0 20px;
  margin:0 auto;
  margin-bottom:10px;
}
.topMessage {
  max-width: 80%;
  width: 900px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue